import { Component, OnInit, Input, SimpleChanges, SimpleChange } from '@angular/core';


@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  @Input() domain: string;
  logoSRC: string 

  constructor() {}

  ngOnInit() {
    this.logoSRC = 
      this.domain.toUpperCase() === 'INFOCERT'
      ? 'https://assets.infocert.it/logos/brands/infocert/white.svg'
      : `../assets/logo/${this.domain}.png`;
  }

  ngOnChanges(changes: SimpleChanges) {
    const domainChange: SimpleChange = changes.domain;
    this.logoSRC =
      domainChange.currentValue.toUpperCase() === 'INFOCERT'
      ? 'https://assets.infocert.it/logos/brands/infocert/white.svg'
      : `../assets/logo/${domainChange.currentValue}.png`;
  }

}
